<template>
  <div v-if="convenioCarregado" id="wrapper">
    <b-card class="m-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="titulo-sagres font-weight-bold">Detalhes do Convênio / Outros Instrumentos Congêneres</span>
          <btn-voltar />
        </h6>
      </template>
      <b-tabs card>
        <b-tab title="Dados gerais">
          <b-row class="m-2">
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>N°/Ano do Instrumento</b></span>
              <br />
              <span class="pos-left">{{ `${convenio.NrConvenio}/${convenio.NrAnoConvenio}` }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Tipo do Instrumento</b></span>
              <br />
              <span class="pos-left">{{ convenio.IdTipoConvenioNavigation.DeTipoConvenio }}</span>
            </b-col>
            <b-col v-if="exibirAutorEmenda" cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Autor da Emenda (vereador)</b></span>
              <br />
              <span class="pos-left">{{ convenio.NmAutorEmenda ? convenio.NmAutorEmenda : '-' }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b> Valor Celebrado (R$)</b></span>
              <br />
              <span class="pos-left">{{ convenio.VlConvenio ? formatMoeda(convenio.VlConvenio) : '-' }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Objeto</b></span>
              <br />
              <span class="pos-left">{{ convenio.DeObjetoConvenio }}</span>
            </b-col>
            <br />
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Início de Vigência</b></span>
              <br />
              <span class="pos-left">{{ convenio.DtInicioVigencia ? formatData(convenio.DtInicioVigencia) :
                '-'
              }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Fim de Vigência</b></span>
              <br />
              <span class="pos-left">{{ convenio.DtFimVigencia ? formatData(convenio.DtFimVigencia) : '-'
              }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Data de Celebração</b></span>
              <br />
              <span class="pos-left">{{ convenio.DtCelebracao ? formatData(convenio.DtCelebracao) : '-'
              }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Data de Publicação</b></span>
              <br />
              <span class="pos-left">{{ convenio.DtPublicacao ? formatData(convenio.DtPublicacao) : '-'
              }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Veículo de Publicação</b></span>
              <br />
              <span class="pos-left">{{ convenio.NmVeiculoPublConv }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Banco</b></span>
              <br />
              <span class="pos-left">{{ convenio.CdBancoConv ? convenio.CdBancoConv : '-'
              }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Agência</b></span>
              <br />
              <span class="pos-left">{{ convenio.CdAgenciaConv ? convenio.CdAgenciaConv : '-'
              }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Conta</b></span>
              <br />
              <span class="pos-left">{{ convenio.NrContaConv ? convenio.NrContaConv : '-' }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Arquivo Texto do Instrumento</b></span>
              <br />
              <div class="d-flex">
                <btn-download :fazerDownload="baixarAnexo" :texto="''" :parametros="'edital'" />
                <span class="pos-left ml-2">Baixar arquivo</span>
              </div>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Data de Cancelamento</b></span>
              <br />
              <span class="pos-left">{{ convenio.DtCancelamentoConv ? formatData(convenio.DtCancelamentoConv) : '-'
              }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Motivo do Cancelamento</b></span>
              <br />
              <span class="pos-left">{{ convenio.DeMotivoCancelConv ? convenio.DeMotivoCancelConv : '-'
              }}</span>
            </b-col>
            <b-col v-if="convenio.DtCancelamentoConv" cols="12" md="6" lg="4" class="text-left mb-2">
              <span><b>Arquivo Cancelamento do Instrumento</b></span>
              <br />
              <div class="d-flex">
                <btn-download :fazerDownload="baixarAnexo" :texto="''" :parametros="'cancelamento'" />
                <span class="pos-left ml-2">Baixar arquivo</span>
              </div>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Participantes">
          <b-table :busy="tableBusy" :fields="fieldsParticipantes" hover no-border-collapse
            :items="convenio.ParticipanteConvenio" sort-by="" :sort-desc="true" striped stacked="sm" per-page="10"
            :current-page="currentPageParticipantes" show-empty small>
            <template #empty>
              <span>Não foram encontrados dados.</span>
            </template>
            <template #emptyfiltered>
              <span>Não foram encontrados dados.</span>
            </template>
            <template #table-busy>
              <div class="text-center text-dark">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="loading-text">Carregando...</strong>
              </div>
            </template>
            <template v-slot:cell(actions)="">
              <div class="d-none" />
            </template>
          </b-table>
          <b-pagination v-model="currentPageParticipantes" :total-rows="convenio.ParticipanteConvenio.length"
            per-page="10" aria-controls="my-table" />
        </b-tab>
        <b-tab title="Histórico de alterações">
          <b-table :busy="tableBusy" :fields="fieldsLogs" hover no-border-collapse :items="itemsLogs" sort-by=""
            :sort-desc="true" striped stacked="sm" per-page="10" :current-page="currentPageLogs" show-empty small>
            <template #empty>
              <span>Não foram encontrados dados.</span>
            </template>
            <template #emptyfiltered>
              <span>Não foram encontrados dados.</span>
            </template>
            <template #table-busy>
              <div class="text-center text-dark">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="loading-text">Carregando...</strong>
              </div>
            </template>
          </b-table>
          <b-pagination v-model="currentPageLogs" :total-rows="itemsLogs.length" per-page="10"
            aria-controls="my-table" />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component';
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import BtnDownload from '@/components/shared/btn-download.vue'

import { store } from "@/store"
import { UtilsTS } from '@/utilsts'

import conveniosService from '@/services/licitacoes/conveniosService'

import { Convenio } from '@/types/licitacoes/convenio'
import { LogEvento } from '@/types/licitacoes/log-evento'
import { fieldsLogsEventos } from '@/types/licitacoes/fields-logs-eventos'
import { fieldsParticipantes } from '@/types/licitacoes/fields-participantes'
import { TableField } from '@/types/table-field';
import { TiposConvenioEnum } from '@/types/licitacoes/enums/tipos-convenio';

const CompProps = Vue.extend({
  name: 'DetalhesConvenio',
  components: { BtnVoltar, BtnDownload },
  props: {
    idConvenio: {
      type: String,
      required: true
    }
  }
})

@Component
export default class DetalhesConvenio extends mixins(UtilsTS, CompProps) {
  tableBusy = false
  convenio: Convenio = new Convenio()
  itemsLogs: LogEvento[] = []
  fieldsLogs: TableField[] = fieldsLogsEventos
  fieldsParticipantes: TableField[] = []
  currentPageLogs = 1
  currentPageParticipantes = 1
  convenioCarregado = false
  exibirAutorEmenda = false

  async created() {
    try {
      this.fieldsParticipantes = fieldsParticipantes.filter(x => x.key !== 'actions')
      store.blockScreen = true
      this.tableBusy = true
      const convenioApi = await conveniosService.buscarConvenio(this.idConvenio)
      if (convenioApi && convenioApi.status === 200) {
        this.convenio = Object.assign(this.convenio, convenioApi.data)
        this.convenio.tratarDadosDaAPI()
        const responseLogs = await conveniosService.listarLogs(this.convenio.IdConvenio);
        if (responseLogs && responseLogs.status === 200) {
          this.itemsLogs = responseLogs.data.map((l: any) => {
            const retorno = Object.assign(new LogEvento(), l)
            if (retorno.TipoLog == 'I')
              retorno.TipoLog = 'Inserção'
            if (retorno.TipoLog == 'U')
              retorno.TipoLog = 'Alteração'
            retorno.DtLog = this.formatDataComHora(retorno.DtLog)
            return retorno
          })
        } else {
          throw new Error(responseLogs.data && responseLogs.data.msg ? responseLogs.data.msg : 'Ocorreu um erro ao realizar a consulta.')
        }
        this.exibirAutorEmenda = this.convenio.IdTipoConvenio === TiposConvenioEnum.EMENDA_IMPOSITIVA_MUNICIPAL
        this.convenioCarregado = true
      } else {
        this.$router.push("/modulo-licitacoes/convenios-outros-instrumentos-congeneres");
        this.$toast.error(convenioApi.data.msg || "Erro ao carregar instrumento");
      }
    } catch (e: any) {
      console.error('Erro ao montar detalhes de instrumento', e)
      this.$router.push("/modulo-licitacoes/convenios-outros-instrumentos-congeneres");
      this.$toast.error(e.message || "Erro ao carregar instrumento");
    } finally {
      this.tableBusy = false
      store.blockScreen = false
    }
  }

  async baixarAnexo(tipo: string) {
    const isEdital = tipo === 'edital' ? true : false
    const arquivo = this.convenio.ArquivoConvenio.find(x => x.IsArquivoEdital === isEdital)
    const response = await conveniosService.baixarAnexo(arquivo?.IdArquivo)
    this.download(arquivo?.DeNomeArquivo, response.data)
  }
};
</script>

<style></style>